import React from "react";

import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";

import LoadingButton from "@mui/lab/LoadingButton";

import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import Divider from "@mui/material/Divider";

export const ActionsGroup = ({
  enableSave,
  generalDisable,
  loading,
  onNewClick,
  onSaveClick,
  onCancelClick,
  direction = "horizontal",
}) => {
  const disabled = !enableSave || generalDisable;
  const tooltipMessage =
    "Save button is disabled until valid modifications are detected";

  if(direction === "horizontal") {
    return (
      <Stack
        direction="row"
        spacing={1}
      >
        <Tooltip arrow title={(disabled && tooltipMessage) || ""}>
          <span>
            <LoadingButton
              loading={loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              sx={{
                boxShadow: "none",
                padding: "5px 12px 4px 12px",
              }}
              color="primary"
              onClick={onSaveClick}
              disabled={disabled}
            >
              Save
            </LoadingButton>
          </span>
        </Tooltip>
        <Tooltip arrow title="Close current configuration">
          <span>
            <Button
              variant="contained"
              sx={{
                boxShadow: "none",
                padding: "5px 12px 4px 12px",
              }}
              color="secondary"
              onClick={onCancelClick}
              disabled={generalDisable}
            >
              Cancel
            </Button>
          </span>
        </Tooltip>
      </Stack>
    );
  }
  if(direction === "vertical") {
    return (
      <Stack
        direction="column"
        spacing={1}
      >
        <Tooltip arrow title="Add new configuration">
            <Button
              variant="contained"
              sx={{
                boxShadow: "none",
                padding: "5px 12px 4px 12px",
              }}
              color="primary"
              startIcon={<AddIcon />}
              onClick={onNewClick}
            >
              New
            </Button>
        </Tooltip>
        <Divider/>
        <Tooltip arrow title="Close current configuration">
            <Button
              variant="contained"
              sx={{
                boxShadow: "none",
                padding: "5px 12px 4px 12px",
              }}
              color="secondary"
              onClick={onCancelClick}
              disabled={generalDisable}
            >
              Cancel
            </Button>
        </Tooltip>
      </Stack>
    );
  }
};
